import * as React from 'react';

import Button from '@/components/elements/Button/BaseButton';
import { LinkIcon } from '@/components/layouts/Race/Singlerace/LiveButton/style';
import { DMM_KEIRIN_YOUTUBE_CH_ID } from '@/config/constants/youtube';
import useLiveVideo from '@/hooks/race/useLiveVideo';
import { Velodrome } from '@/modelTypes';

export interface LiveButtonProps {
  velodrome: Velodrome;
  device: 'pc' | 'sp';
}

export const LiveButton: React.FC<LiveButtonProps> = ({
  velodrome,
  device,
}) => {
  const { liveLink, isReplaced } = useLiveVideo(velodrome);

  return (
    <a
      href={
        isReplaced
          ? `https://www.youtube.com/channel/${DMM_KEIRIN_YOUTUBE_CH_ID}/live`
          : liveLink.url
      }
      target="_blank"
      title={isReplaced ? 'YouTube 【公式】DMM競輪ch' : liveLink.liveSite}
      rel="noreferrer"
    >
      <Button
        size={device === 'pc' ? 's' : 'xs'}
        bgColor="secondary"
        outline
        width={device === 'pc' ? '100%' : '60px'}
        height={device === 'pc' ? '46px' : '36px'}
        radius={device === 'pc' ? 'm' : 's'}
      >
        LIVE
        <LinkIcon device={device} />
      </Button>
    </a>
  );
};

export default LiveButton;
